import { render } from "./AccountTag.vue?vue&type=template&id=756aea90&ts=true"
import script from "./AccountTag.vue?vue&type=script&lang=ts"
export * from "./AccountTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__